export default {
  rule: {
    title: 'Rule',
    productCriteria: 'Candidate Product Eligibility Criteria',
    type: 'Inventory Types',
    FBKLabel: 'FBK 【Fulfilled By Kilimall】',
    GSLabel: 'GS 【Local Dispatch】',
    DSLabel: 'DS 【Local Dispatch】',
    PUBLabel: 'PUB【Local Dispatch】',
    category: 'Prohibited Category',
    keywords: 'Prohibited Keywords',
    pStatus: 'Product Status',
    pStatusValue: 'Normally listed for sale',
    iStatus: 'Inventory Status',
    iStatusValue: 'Available inventory',
    sStatus: 'Shop Status',
    sStatusValue: 'Shop is not frozen, on hiatus, or closed',
    requirement: 'Sales Requirement',
    Limit: 'Registration Frequency Limit',
    eachOf: 'Each shop can register a maximum of ',
    listingDay: 'listing products in one day',
    ForOf: 'For the same listing product, you can register for a maximum of ',
    sessionDay: 'session in one day',
    registrationCriteria: 'Registration Eligibility Criteria',
    inventoryRequirements: 'Inventory Quantity Requirements',
    FBKQuantity: 'FBK SKU Inventory Quantity >= ',
    GSQuantity: 'GS SKU Inventory Quantity >= ',
    DSQuantity: 'DS SKU Inventory Quantity >= ',
    PUBQuantity: 'PUB SKU Inventory Quantity >= ',
    ifInventorySuffice: 'If inventory quantity requirements include two or more inventory types, meeting any one of them will suffice',
    registrationRequirements: 'Registration Price Requirements',
    qtyRequirements: ' Inventory Quantity Requirements',
    theLeast: 'The registration price must be at least ',
    belowLast: ' below the lowest selling price in the last ',
    days: ' days',
    lowerLast: ' lower than the lowest selling price in the last ',
    ifPriceSuffice: 'If price requirements include two or more, meeting any one of them will suffice'
  },
  applicationList: {
    title: 'Apply for Flashsale',
    errorTip: 'Ineligibility Reason: ',
    rule: 'Rule',
    pName: 'Product Name',
    category: 'Category',
    all: 'All',
    pInformation: 'Product information',
    priceRange: 'Price Range',
    inventory: 'Inventory',
    apply: 'Apply'
  },
  applicationManage: {
    title: 'Flashsale Management',
    statu: 'status',
    oPrice: 'Original Price',
    ePrice: 'Event Price',
    eInventory: 'Event Inventory',
    eSold: 'Event Sold',
    sTime: 'Start Time',
    operation: 'Operation',
    btnView: 'Event Details',
    btnCancel: 'Cancel',
    btnEditor: 'Edit',
    btnReason: 'Rejection Reason',
    deleteBoxTitle: 'Confirm Cancel Registration?',
    deleteBoxConfirm: 'Confirm',
    deleteBoxCancel: 'Cancel'
  },
  application: {
    reselectProducts: 'Reselect Products',
    stateSubmitted: 'Submitted',
    statePending: 'Pending',
    title: 'Edit Event Product Information',
    purchaseLimitMode: 'Purchase Limit Mode',
    radioPurchase: 'One item per customer per session.',
    radioPerson: 'One item per customer, all sessions.',
    radioLimited: 'No restrictions.',
    expectedTime: 'Expected Time',
    selectDate: 'Select Date',
    selectStartSession: 'Select Start Session',
    disableVoucher: 'Disable Voucher',
    InventoryType: 'Inventory Type',
    batchSettings: 'Batch Settings',
    discount: 'Discount',
    fixedAmount: 'Fixed Amount',
    reduce: 'Reduce',
    setPriceInBatch: 'Set price in batch',
    setInventoryInBatch: 'Set ',
    setInventoryInBatchEnd: ' Inventory in batch',
    confirm: 'Confirm',
    specification: 'Specification',
    lowestLast: 'Lowest Selling Price in the Last ',
    day: ' Days ',
    daysPrice: '(Excluding Flash Sale Price)',
    currentPrice: 'Current Price',
    inventory: 'Inventory',
    eventInventory: 'Event Inventory',
    eventPrice: 'Event Price',
    submit: 'Submit',
    yes: 'YES',
    no: 'NO',
    expectedTimeMsg: 'Please choose the expected time',
    fbkPlaceholder: 'FBK store:',
    pubPlaceholder: ' store:',
    nullStore: 'Out of Stock',
    min: 'Min ',
    max: ', Max ',
    pricePlaceholder: 'Please enter event price',
    skuNullMsg: 'Please select the SKU before submitting.',
    the: 'The',
    priceOrQtyNull: ' does not meet the registration criteria for price/stock quantity. Please fill out the form again.',
    priceTip: 'The spike price you set is too low, there is a risk of loss, are you sure?'
  },
  details: {
    title: 'Event Product Information',
    startDate: 'Start Time'
  },
  msg: {
    successfully: 'Submitted successfully'
  },
  title: {
    flashSaleList: 'Flash Sale List',
    flashSaleApplication: 'Flash Sale Application',
    rule: 'Rule',
    flashSaleManage: 'Flash Sale Management',
    flashSaleDetails: 'Flash Sale Details'
  }
}
